import { getProduct } from '#/products/domain';
import { Bbo } from '#/unified-rfqs/entities/drfq/bbo';
import { DrfqLeg } from '#/unified-rfqs/entities/drfq/domain';
import { NEGATIVE_SIGN } from '@paradigm/utils/src/enhanceNegativeSign';
import { NullableTwoWay } from '../form-reducer';

export interface LegPriceView {
  readonly bid: string | null;
  readonly ask: string | null;
  readonly key: string;
  readonly markPrice: string;
  readonly markPriceIv: string;
  readonly instrumentId: number;
  readonly placeholder: string;
  readonly precision: number;
  readonly side: 'BUY' | 'SELL';
}

export interface LegsPricesView {
  readonly legs: readonly LegPriceView[];
  readonly isLoading: boolean;
}

export default function legsPricesView(
  rawLegs: readonly NullableTwoWay[],
  bbo: Bbo | null,
  legs: readonly DrfqLeg[],
  isLegPricesLoading: boolean,
): LegsPricesView {
  const processLegInput = createLegInputProcessor(bbo, legs);
  return {
    legs: rawLegs.map(processLegInput),
    isLoading: isLegPricesLoading,
  };
}

function createLegInputProcessor(bbo: Bbo | null, legs: readonly DrfqLeg[]) {
  return function processLegInput(
    [bid, ask]: NullableTwoWay,
    index: number,
  ): LegPriceView {
    const leg = legs[index]!;
    const markPriceIv = bbo?.legs[index]?.mark_price_iv ?? '';

    const { pricePrecision } = getProduct(leg.product_code);
    return {
      bid,
      ask,
      instrumentId: leg.instrument_id,
      side: leg.side,
      placeholder: NEGATIVE_SIGN,
      markPrice: bbo?.legs[index]?.mark_price ?? '',
      key: `leg-input-price-${index}`,
      precision: pricePrecision,
      markPriceIv,
    };
  };
}
